import { Stack } from '@stereograph/teia-system-design/components/Stack';
import { AnomalyDocumentProvider } from '../../context/AnomalyDocumentContext';
import { AnomalyDocument, AnomalyDocumentCard } from './AnomalyDocumentCard';

interface AnomalyDocumentListProps {
  documents: Array<AnomalyDocument>;
}

export const AnomalyDocumentList = (props: AnomalyDocumentListProps) => {
  const { documents } = props;

  return (
    <Stack direction="row" flexWrap="wrap" spacing={4}>
      {documents.map((document) => (
        <AnomalyDocumentProvider
          anomalyDocument={document}
          key={`document-provider-${document.id}`}
        >
          <AnomalyDocumentCard />
        </AnomalyDocumentProvider>
      ))}
    </Stack>
  );
};
